<template>
    <div v-if="store.state.showingModal == 'bake-image'" class="b3-dialog-box">
        <div class="b3-modal">
            <div id="bake-image-panel">
                <h2>{{t('convert image dialog title','Convert Image')}}</h2>
                <div v-show="!store.state.bakeImageModal.limitBake" class="b3-form-option">
                    <label id="number-of-colors-label" for="bakePaletteSize">{{t('convert image number of colors','Number of Colors')}}</label>
                    <input v-model="store.state.bakeImageModal.bakePaletteSize" type="number" id="bakePaletteSize" name="bakePaletteSize" min="2">
                </div>
                <div class="b3-form-option">
                    <label for="limitBake">{{t('convert image use only palette','Use only styles in palette')}}</label>
                    <input v-model="store.state.bakeImageModal.limitBake" type="checkbox" id="limitBake" name="limitBake">
                    <span class="tooltip">ⓘ<span class="tooltiptext">{{t('convert image use only palette tip','Converts using the styles you already have in your palette.')}}</span></span>
                </div>
                <div class="b3-form-option" id="bake-method-div">
                    <label for="bakeMethod">{{t('convert image conversion method','Conversion Method:')}}</label>
                    <select v-model="store.state.bakeImageModal.bakeMethod" id="bakeMethod" name="bakeMethod">
                        <option value="RGB">{{t('convert image rgb method','RGB')}}</option>
                        <option value="HSV">{{t('convert image hsv method','HSV')}}</option>
                    </select>
                    <span class="tooltip">ⓘ<span class="tooltiptext">{{t('convert image conversion method tip','The method by which the app compares colors during the conversion process. Use RGB by default.')}}</span></span>
                </div>
                <button @click="doBake">{{t('convert image convert button','Convert')}}</button>
                <button @click="closeDialog">{{t('cancel','Cancel')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { bake } from '../myapp/src/procedures/newbake.js';
export default {
    name: 'Bake Image Dialog',
    methods: {
        doBake() {
            bake(
                this.store.state.bakeImageModal.bakePaletteSize,
                this.store.state.bakeImageModal.bakeMethod,
                this.store.state.bakeImageModal.limitBake
            );
        },
        closeDialog() {
            b3.menu.closeBakeDialog();
        }
    }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';

#bake-image-panel {
    background-color: $off-white;
    padding: 10px 40px 30px;
    margin-top: 40px;
    width: 300px;
}

</style>